import { Room } from 'Interfaces/JobsInterface';
import { JOB_TYPES, PRIORITY_TYPE, roomList, sortRoomsByPriority } from 'config/Constants';
import { parseISOStringToDateWithoutTimezoneConversion } from 'utils/jobStartTimeUtilities';

export const fetchJobsServerResponseToUIObject = (rooms: Omit<Room, 'color'>[]): Room[] => {
  // First map room info with colors
  const roomsWithColor = rooms.map(room => {
    const matchingRoom = roomList.find(item => item.value === room.shortCode);
    return {
      ...room,
      color: matchingRoom ? matchingRoom.color : '#CCCCCC', // Default gray color if no match found
      jobs: room.jobs
        .map(job => {
          // Extract needed data or use defaults
          const jobDataToSave = job;
          const roomLongCode = room.name || '';

          return {
            id: job?.id,
            jobId: job?.jobId,
            serial: Number(job?.serial || jobDataToSave.priority || 0),
            priority: (job?.priority || jobDataToSave.priority || '') as PRIORITY_TYPE,
            status: String(job?.status || jobDataToSave.status || '') as JOB_TYPES,
            room: String(roomLongCode.toLowerCase()),
            ndc: String(job?.ndc || jobDataToSave.ndc || ''),
            description: job?.description || jobDataToSave.description || '',
            qtyOfContainers: Number(job?.qtyOfContainers || jobDataToSave.qtyOfContainers || -1),
            qtyPerContainer: Number(job?.qtyPerContainer || jobDataToSave.qtyPerContainer || -1),
            type: job?.type || jobDataToSave.type || '',
            qtyUnitsToPackage: job?.qtyUnitsToPackage || jobDataToSave.qtyUnitsToPackage,
            confirmedDate:
              job?.confirmedDate || (jobDataToSave.confirmedDate as unknown as string) || '',
            notes: job?.notes || [],
            cleanProjected: job?.cleanProjected || null,
            bpmProjected: job?.bpmProjected !== null ? Number(job?.bpmProjected) : null,
            cleanOverride: job?.cleanOverride || null,
            bpmOverride: job?.bpmOverride || null,
            numberOfBottlesInAtShiftStart:
              job?.numberOfBottlesInAtShiftStart !== null ? job?.numberOfBottlesInAtShiftStart : null,
            jobStartTime: job?.jobStartTime
              ? parseISOStringToDateWithoutTimezoneConversion(job.jobStartTime as string)
              : null
          };
        })
        .sort((a, b) => (a.serial || 0) - (b.serial || 0)) // Sort jobs by serial number
    };
  });

  // Apply the custom room ordering before returning
  return sortRoomsByPriority(roomsWithColor);
};
